// Lightweight local persistence with proper error handling.
// NOTE: Only non-sensitive UI state is stored here (bookmarks, recents, attempts).
const KEYS = {
  bookmarks: 'solveit_bookmarks',
  attempts: 'solveit_attempts',
  recent: 'solveit_recent_topics',
};

function read(key, fallback) {
  try {
    const raw = typeof window !== 'undefined' ? window.localStorage.getItem(key) : null;
    return raw ? JSON.parse(raw) : fallback;
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[storage] read failed for', key, err);
    }
    return fallback;
  }
}
function write(key, val) {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(key, JSON.stringify(val));
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[storage] write failed for', key, err);
    }
  }
}

export const bookmarkStore = {
  list() { return read(KEYS.bookmarks, []); },
  has(id) { return this.list().includes(id); },
  toggle(id) {
    const list = this.list();
    const next = list.includes(id) ? list.filter(x => x !== id) : [...list, id];
    write(KEYS.bookmarks, next);
    return next.includes(id);
  },
};

export const attemptStore = {
  all() { return read(KEYS.attempts, {}); },
  set(id, choice) {
    const all = this.all();
    all[id] = choice;
    write(KEYS.attempts, all);
  },
  get(id) { return this.all()[id]; },
};

export const recentStore = {
  list() { return read(KEYS.recent, []); },
  push(entry) {
    const list = this.list().filter(e => !(
      e.subjectId === entry.subjectId &&
      e.sectionId === entry.sectionId &&
      e.topicId === entry.topicId
    ));
    list.unshift({ ...entry, ts: Date.now() });
    write(KEYS.recent, list.slice(0, 6));
  },
};
